export const paramsData = {
  cloudId: 139,
  appId: 20561,
  gameId: 20561,
  clientId: 'H5_5.0_tuyoo.tuyoo.0-hall20561.yuenan.gw',
  chAppId: "10000399"
}
export const resizeHtml = `(function (win, doc) {
  // console.log('win', win)
  // console.log('doc', doc)
  if (!win.addEventListener) return
  // var html = document.documentElement
  function setFont() {
    var html = document.documentElement
    let width = html.clientWidth

    html.style.fontSize = width / 1920 + 'px'
  }
  setFont()
  // setTimeout(function () {
  //   setFont()
  // }, 300)
  doc.addEventListener('DOMContentLoaded', setFont, false)
  win.addEventListener('resize', setFont, false)
  win.addEventListener('load', setFont, false)
})(window, document)`

export const resizeHtml_m = `(function (win, doc) {
  // console.log('win', win)
  // console.log('doc', doc)
  if (!win.addEventListener) return
  // var html = document.documentElement
  function setFont() {
    var html = document.documentElement
    let width = html.clientWidth

    html.style.fontSize = width / 375 + 'px'
  }
  setFont()
  // setTimeout(function () {
  //   setFont()
  // }, 300)
  doc.addEventListener('DOMContentLoaded', setFont, false)
  win.addEventListener('resize', setFont, false)
  win.addEventListener('load', setFont, false)
})(window, document)`  
const { cache } = useCache('local')
export const defaultP = {
  region: 'VN',
  appId: paramsData.appId,
  userId: cache.get('TU_USER') ? JSON.parse(cache.get('TU_USER')).userId : ''
}
export const general = {
  "channelType": "username.vn.app",
  "ChargeType": "tthonepay.sea.h5",
  "reset_guest": false,                                        //是否重置游客账号
  "pay_version": "hall37",                                     //支付版本hall37还是hall51
  "debug": false,
  "bi_base_url": "https://cbi.tuyoorock.com/",
  "appId": paramsData.appId,
  "gameId": paramsData.gameId,
  "cloudId": paramsData.cloudId,                                              //跟运维确认
  "clientId": paramsData.clientId,
  "all": true,
  "userId": defaultP.userId,
  "app_serverId": "com.tuyoo.fish3d.iosjp.h5v2",
  "teamId": "8N6L3ANP2R",
  "fb_appid": "1926932707785503",
  "fb_version": "v20.0",
  "google_client_id": "600946685193-u1c8pqij6apbtbn69cf23ke7o843ub57.apps.googleusercontent.com",
};
cache.set('TU_CLOUDID', paramsData.cloudId)
cache.set('TU_APPID', paramsData.appId)
cache.set('TU_GAMEID', paramsData.gameId)
cache.set('TU_CLIENTID', paramsData.clientId)
